import { render, staticRenderFns } from "./AlertLifeCycleModal.vue?vue&type=template&id=b53b6182&"
import script from "./AlertLifeCycleModal.vue?vue&type=script&lang=js&"
export * from "./AlertLifeCycleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports